<template>
  <div  class="loot-box-item">
    <div class="d-flex align-items-center">
      <div class="icon">
        <img :src="lootBox.iconUrl">
      </div>
      <div class="info">
        <div class="name">{{ item.name }}</div>
        <div class="coins">
          <img src="/img/coins/gold_coin.svg">
          <span>{{ numberFormatter.formatNumber(min)}} - {{ numberFormatter.formatNumber(max)}}</span>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center align-items-center">
      <button :disabled="buyBtnDisabled" @click.prevent="buy" class="btn btn-primary text-nowrap"><span class="text-capitalize-first">{{numberFormatter.formatMoney(item.price)}}</span></button>
    </div>
  </div>
</template>
<style scoped>
.loot-box-item {
  border-radius: var(--border-radius);
  background-color: var(--header-bg);
  padding: var(--margin-normal);
  display: flex;
  gap: var(--margin-xs);
  justify-content: space-between;

  .info {
    display: flex;
    flex-direction: column;
    gap: var(--margin-xxs);

    .name {
      font-weight: 700;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0.5%;

    }
  }
  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: var(--margin-normal);
    position: relative;
    &::before {
      background: #C4F82A;
      content: "";
      position: absolute;
      width: 40px;
      height: 40px;
      filter: blur(30px);
      opacity: 50%;
      border-radius: 100px;
    }
    img {
      width: 56px;
      height: 56px;
      position: relative;
    }
  }
  .coins {
    display: flex;
    align-items: center;
    gap: var(--margin-xxs);
    img {
      width: 16px;
      height: 16px;
    }
    span {
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0%;

    }
  }
}
</style>
<script lang="ts" setup>
import StoreItemDTO from "@/models/StoreItemDTO";
import {numberFormatter} from "@/service/NumberFormatter";
import {computed} from "vue";
import {useStore} from "vuex";
import { AppEvents } from "@/models/enum/AppEvents";
import StoreLootBoxDTO from "@/models/StoreLootBoxDTO";
import MoneyDTO from "@/models/MoneyDTO";
import {useRouter} from "vue-router";

const props = defineProps<{
  item: StoreItemDTO,
  buyBtnDisabled?: boolean
}>()

const store = useStore();
const router = useRouter();

const buy = () => {
  if (!store.getters.isLoggedIn) {
    router.push({name: 'login'})
    return;
  }

  store.dispatch('emit', {event: AppEvents.SHOW_LOOT_BOX, data: props.item})
}
const lootBox = computed(() => {
  return props.item.content as StoreLootBoxDTO
})

const min = computed((): MoneyDTO => {
  return lootBox.value?.items[0].sum
})

const max = computed((): MoneyDTO => {
  return lootBox.value?.items[lootBox.value?.items.length - 1].sum
})
</script>
